import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData } from "../../../services/api";
import { hideAddTierModal } from "./tierModalDispatcher";

// ➝ Add / Update Tier
export const addTierRequest = (data, navigate) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_TIER_REQUEST" });
    try {
      // if data.id exists → update, else → create new
      const tierResponse = (data.id)
        ? await updateData(data, `${ApiURLs.TIER}/${data.id}`)
        : await postData(data, ApiURLs.TIER);

      if (tierResponse.status === 1) {
        dispatch({ type: "ADD_TIER_SUCCESS" });
        dispatch(hideAddTierModal());
        dispatch(tierListingRequest());
      } else {
        dispatch({ type: "ADD_TIER_FAILED" });
      }
    } catch (error) {
      console.error("Error adding/updating tier:", error);
      dispatch({ type: "ADD_TIER_FAILED" });
    }
  };
};

// ➝ Get all Tiers
export const tierListingRequest = () => {
  return async (dispatch) => {
    dispatch({ type: "GET_TIER_REQUEST" });
    try {
      const url = `${ApiURLs.TIER}`;
      const tierData = await fetchData(url);
      console.log("Response when fetching tiers:", tierData);

      if (tierData.status === 1) {
        dispatch({
          type: "GET_TIER_REQUEST_SUCCESS",
          payload: tierData.data.result,
        });
      } else {
        dispatch({ type: "GET_TIER_REQUEST_FAILED" });
      }
    } catch (error) {
      console.error("Error fetching tier list:", error);
      dispatch({ type: "GET_TIER_REQUEST_FAILED" });
    }
  };
};

// ➝ Get single Tier Detail
export const getTierDetail = (id) => {
  return async (dispatch) => {
    try {
      const url = `${ApiURLs.TIER}/${id}`;
      const response = await fetchData(url);
      if (response.status === 1) {
        dispatch({
          type: "GOT_TIER_DETAIL",
          payload: response.data,
        });
      }
    } catch (error) {
      console.error("Error fetching tier detail:", error);
    }
  };
};

// ➝ Delete Tier
export const deleteTier = (id) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_TIER_REQUEST" });
    try {
      const response = await deleteData(`${ApiURLs.TIER}/${id}`);
      if (response.status === 1) {
        dispatch({ type: "DELETE_TIER_SUCCESS" });
        dispatch(tierListingRequest());
      } else {
        dispatch({ type: "DELETE_TIER_FAILED" });
      }
    } catch (error) {
      console.error("Error deleting tier:", error);
      dispatch({ type: "DELETE_TIER_FAILED" });
    }
  };
};


    export const getTierListing = () => {

    return async (dispatch) => {
      const url = `${ApiURLs.TIER}?limit=20`;
        try {
        var tierResData = await fetchData(url);
        console.log(`response when we try to get tiers ${JSON.stringify(tierResData)}`)
        if (tierResData.status === 1) {
         return tierResData.data.result;
        
        } else {
          return [];
        }
      } catch (error) {
        console.log(`error while try to tier ${error}`)

        return [];
      }
    }
  };
